// extracted by mini-css-extract-plugin
export var cartIcon = "_js-0";
export var cartIconContainer = "_js-1";